export var UiDomains;
(function (UiDomains) {
    UiDomains["ELT"] = "ELT";
    UiDomains["AI"] = "AI";
    UiDomains["EMBEDDED"] = "EMBEDDED";
    UiDomains["SYMON"] = "Symon.AI";
})(UiDomains || (UiDomains = {}));
export const DomainNameMap = new Map([
    [UiDomains.ELT, 'Varicent ELT'],
    [UiDomains.AI, 'Varicent AI'],
    [UiDomains.SYMON, 'Symon.AI']
]);
//# sourceMappingURL=uiDomains.js.map